import { render, staticRenderFns } from "./FitnessAssessments.vue?vue&type=template&id=012194de&"
import script from "./FitnessAssessments.vue?vue&type=script&lang=js&"
export * from "./FitnessAssessments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports